<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="columns box">
            <div class="column is-5">
                <b-field>
                    <b-input :placeholder="$t('CONVENIOS.PROCURAR')"
                             v-model="procurar"
                             icon="magnify"
                             @input="loadAsyncData"></b-input>
                </b-field>
            </div>
            <div class="column">
                <div class="is-flex is-justified-between">
                    <router-link
                        v-if="isInRole('convenio-alterar')  && 
                                integradores.filter(x => x.ativo && x.versao == 30).length == 0"
                        :to="{ name: 'convenio' }"
                        class="button is-primary"
                        >
                        Incluir
                    </router-link>
                </div>                
            </div>               
            <div class="column is-2">
                <form @submit.prevent="abrirCadastroInput">
                    <b-field>
                        <b-input :placeholder="$t('CONVENIOS.CODIGO')"
                                 v-model="id"
                                 type="number"
                                 icon-right="edit"
                                 icon-right-clickable
                                 @icon-right-click="abrirCadastroInput">
                        </b-input>
                    </b-field>
                </form>
            </div>
        </div>
        <b-table :data="model.lista"
                 :loading="loading"
                 paginated
                 striped
                 hoverable
                 backend-pagination
                 :total="total"
                 @page-change="onPageChange"
                 :aria-next-label="$t('CONVENIOS.PROXPAGINA')"
                 :aria-previous-label="$t('CONVENIOS.PAGANTERIOR')"
                 :aria-page-label="$t('CONVENIOS.PAGINA')"
                 :aria-current-label="$t('CONVENIOS.PAGATUAL')"
                 backend-sorting
                 :default-sort-direction="defaultOrdenar"
                 :default-sort="[ordenarPor, ordenar]"
                 sort-icon-size="is-small"
                 @sort="onSort">

            <template @click="abrirCadastro(props.row.id)">
                <b-table-column v-slot="props" field="id" :label="$t('CONVENIOS.ID')" sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column v-slot="props" field="Nome" :label="$t('CONVENIOS.NOME')" sortable>
                    {{ props.row.nome }}
                </b-table-column>

                <b-table-column v-slot="props" field="TipoConvenio" :label="$t('CONVENIOS.TIPOCONV')" sortable>
                    {{ props.row.tipoConvenioNome }}
                </b-table-column>

                <b-table-column v-slot="props" field="TabelaPreco" :label="$t('CONVENIOS.TABPRECO')" sortable>
                    {{ props.row.tabelaPrecoNome }}
                </b-table-column>

                <b-table-column v-slot="props" field="" label="" sortable>
                    <span v-if="props.row.particular" class="tag is-success">{{$t('CONVENIOS.PARTICULAR')}}</span>
                </b-table-column>

                <b-table-column v-slot="props" field="" label="" sortable>
                    <span v-if="props.row.reembolso" class="tag is-success">{{$t('CONVENIOS.REEMBOLSO')}}</span>
                </b-table-column>                

                <b-table-column v-slot="props" custom-key="actions" numeric>
                    <router-link :to="{ name: 'convenio', params: { id: props.row.id }}" class="button is-small is-primary" :title="$t('CONVENIOS.EDITAR')">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>
                </b-table-column>
            </template>
        </b-table>
    </section>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'
    import titlebar from '@/components/titlebar.vue'

    export default {
        data() {
            return {
                model: [],
                total: 0,
                loading: false,
                procurar: this.$route.query.procurar ?? '',
                ordenarPor: 'Nome',
                ordenar: 'asc',
                defaultOrdenar: 'asc',
                page: 1,
                perPage: 20,
                selecionado: null,
                id: null
            }
        },
        components: {
            titlebar
        },
        computed: {
            titleStack() {
                return [
                    this.$t('CONVENIOS.MANUTENCAO'),
                    this.$t('SISTEMA.CONVENIO')+"s",
                ]
            },
            ...mapGetters([
                'isInRole'
            ]),
            ...mapState([
                'integradores'
            ])
        },
        methods: {
           loadAsyncData() {
                const params = [
                    `procurar=${this.procurar}`,
                    `ordem=${this.ordenarPor}.${this.ordenar}`,
                    `page=${this.page}`
                ].join('&')

                this.loading = true
                this.$http.get(`/api/manutencao/convenios?${params}`)
                    .then(({ data }) => {
                        this.model = data;
                        if (data.lista.length == 0 && this.page > 1) {
                            this.page = 1
                            this.loadAsyncData()
                        }
                        this.total = this.perPage * data.pageCount
                        this.loading = false
                        this.$router.replace({query: {procurar: this.procurar, page: this.page }})
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.ordenarPor = field
                this.ordenar = order
                this.loadAsyncData()
            },
            abrirCadastro() {
                this.$router.push({ path: `/manutencao/convenio/${this.selecionado.id}` })
            },
            abrirCadastroInput() {
                this.$router.push({ path: `/manutencao/convenio/${this.id}` })
            },
        },
        mounted() {
            this.loadAsyncData()
        }
    }
</script>